module.exports = __webpack_public_path__ + "static/media/17.55783e2a.jpg";